import { Regexxgw0gjiagf4z as Regex } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isCharSequence1ju9jr1w86plq as isCharSequence,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  substringiqarkczpya5m as substring,
  substring3saq8ornu0luv as substring_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { STRING_getInstance7xungxdjbzv as STRING_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  Exceptiondt2hlxn7j7vw as Exception,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import {
  trim11nh7r46at6sx as trim,
  startsWith1bgirhbedtv2y as startsWith_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  Char19o2r8palgjof as Char,
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_emailRegex() {
  _init_properties_StringAlts_kt__fevqij();
  return emailRegex;
}
var emailRegex;
function get_punctuation() {
  _init_properties_StringAlts_kt__fevqij();
  return punctuation;
}
var punctuation;
function _EmailAddress___init__impl__a6ugvr(raw) {
  return raw;
}
function _EmailAddress___get_raw__impl__6ose2($this) {
  return $this;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.commentRegex_1 = Regex().new_kotlin_text_Regex_acuq4a_k$('\\([^)]+\\)');
      }
      serializer_9w0wvi_k$() {
        return EmailAddressSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function EmailAddress__toString_impl_artjh3($this) {
  return _EmailAddress___get_raw__impl__6ose2($this);
}
function _EmailAddress___get_url__impl__h7wdun($this) {
  return 'mailto:' + _EmailAddress___get_raw__impl__6ose2($this);
}
function EmailAddress__hashCode_impl_wizg9y($this) {
  return getStringHashCode($this);
}
function EmailAddress__equals_impl_pzzdfa($this, other) {
  if (!(other instanceof EmailAddress()))
    return false;
  if (!($this === other.raw_1))
    return false;
  return true;
}
function EmailAddress__compareTo_impl_sv1ebf($this, other) {
  return $this.compareTo_p594d2_k$((!(other == null) ? isInterface(other, IsRawString()) : false) ? other : THROW_CCE());
}
var EmailAddressClass;
function EmailAddress() {
  if (EmailAddressClass === VOID) {
    class $ {
      constructor(raw) {
        Companion_getInstance();
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _EmailAddress___get_raw__impl__6ose2(this.raw_1);
      }
      toString() {
        return EmailAddress__toString_impl_artjh3(this.raw_1);
      }
      hashCode() {
        return EmailAddress__hashCode_impl_wizg9y(this.raw_1);
      }
      equals(other) {
        return EmailAddress__equals_impl_pzzdfa(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return EmailAddress__compareTo_impl_sv1ebf(this, other);
      }
    }
    protoOf($).compareTo_p594d2_k$ = compareTo_0;
    initMetadataForClass($, 'EmailAddress', VOID, VOID, [IsRawString()], VOID, VOID, {0: EmailAddressSerializer_getInstance});
    EmailAddressClass = $;
  }
  return EmailAddressClass;
}
function _PhoneNumber___init__impl__slwhzy(raw) {
  return raw;
}
function _PhoneNumber___get_raw__impl__gc2pmp($this) {
  return $this;
}
function PhoneNumber__toString_impl_7i2x3q($this) {
  return startsWith(_PhoneNumber___get_raw__impl__gc2pmp($this), '+1') ? '+1 (' + substring(_PhoneNumber___get_raw__impl__gc2pmp($this), 2, 5) + ') ' + substring(_PhoneNumber___get_raw__impl__gc2pmp($this), 5, 8) + '-' + substring_0(_PhoneNumber___get_raw__impl__gc2pmp($this), 8) : _PhoneNumber___get_raw__impl__gc2pmp($this);
}
function _PhoneNumber___get_url__impl__12igm0($this) {
  return 'tel:' + _PhoneNumber___get_raw__impl__gc2pmp($this);
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return PhoneNumberSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function PhoneNumber__hashCode_impl_t98twl($this) {
  return getStringHashCode($this);
}
function PhoneNumber__equals_impl_svvo3b($this, other) {
  if (!(other instanceof PhoneNumber()))
    return false;
  if (!($this === other.raw_1))
    return false;
  return true;
}
function PhoneNumber__compareTo_impl_1hrt7o($this, other) {
  return $this.compareTo_p594d2_k$((!(other == null) ? isInterface(other, IsRawString()) : false) ? other : THROW_CCE());
}
var PhoneNumberClass;
function PhoneNumber() {
  if (PhoneNumberClass === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _PhoneNumber___get_raw__impl__gc2pmp(this.raw_1);
      }
      toString() {
        return PhoneNumber__toString_impl_7i2x3q(this.raw_1);
      }
      hashCode() {
        return PhoneNumber__hashCode_impl_t98twl(this.raw_1);
      }
      equals(other) {
        return PhoneNumber__equals_impl_svvo3b(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return PhoneNumber__compareTo_impl_1hrt7o(this, other);
      }
    }
    protoOf($).compareTo_p594d2_k$ = compareTo_0;
    initMetadataForClass($, 'PhoneNumber', VOID, VOID, [IsRawString()], VOID, VOID, {0: PhoneNumberSerializer_getInstance});
    PhoneNumberClass = $;
  }
  return PhoneNumberClass;
}
var EmailAddressSerializerClass;
function EmailAddressSerializer() {
  if (EmailAddressSerializerClass === VOID) {
    class $ {
      constructor() {
        EmailAddressSerializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('com.lightningkite.services.data.EmailAddress', STRING_getInstance());
      }
      deserialize_q7n566_k$(decoder) {
        // Inline function 'com.lightningkite.services.data.deserializing' call
        var tmp;
        try {
          tmp = new (EmailAddress())(toEmailAddress(decoder.decodeString_x3hxsx_k$()));
        } catch ($p) {
          var tmp_0;
          if ($p instanceof SerializationException()) {
            var e = $p;
            throw e;
          } else {
            if ($p instanceof Exception()) {
              var e_0 = $p;
              throw SerializationException().new_kotlinx_serialization_SerializationException_pjmzgo_k$('Not a valid ' + this.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + ': ' + e_0.message, e_0);
            } else {
              throw $p;
            }
          }
        }
        return tmp.raw_1;
      }
      deserialize_sy6x50_k$(decoder) {
        return new (EmailAddress())(this.deserialize_q7n566_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_lz0pa3_k$(encoder, value) {
        return encoder.encodeString_424b5v_k$(_EmailAddress___get_raw__impl__6ose2(value));
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_lz0pa3_k$(encoder, value instanceof EmailAddress() ? value.raw_1 : THROW_CCE());
      }
    }
    initMetadataForObject($, 'EmailAddressSerializer', VOID, VOID, [KSerializer()]);
    EmailAddressSerializerClass = $;
  }
  return EmailAddressSerializerClass;
}
var EmailAddressSerializer_instance;
function EmailAddressSerializer_getInstance() {
  if (EmailAddressSerializer_instance === VOID)
    new (EmailAddressSerializer())();
  return EmailAddressSerializer_instance;
}
var PhoneNumberSerializerClass;
function PhoneNumberSerializer() {
  if (PhoneNumberSerializerClass === VOID) {
    class $ {
      constructor() {
        PhoneNumberSerializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('com.lightningkite.services.data.PhoneNumber', STRING_getInstance());
      }
      deserialize_bfsjhb_k$(decoder) {
        // Inline function 'com.lightningkite.services.data.deserializing' call
        var tmp;
        try {
          tmp = new (PhoneNumber())(toPhoneNumber(decoder.decodeString_x3hxsx_k$()));
        } catch ($p) {
          var tmp_0;
          if ($p instanceof SerializationException()) {
            var e = $p;
            throw e;
          } else {
            if ($p instanceof Exception()) {
              var e_0 = $p;
              throw SerializationException().new_kotlinx_serialization_SerializationException_pjmzgo_k$('Not a valid ' + this.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + ': ' + e_0.message, e_0);
            } else {
              throw $p;
            }
          }
        }
        return tmp.raw_1;
      }
      deserialize_sy6x50_k$(decoder) {
        return new (PhoneNumber())(this.deserialize_bfsjhb_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_z73n68_k$(encoder, value) {
        return encoder.encodeString_424b5v_k$(_PhoneNumber___get_raw__impl__gc2pmp(value));
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_z73n68_k$(encoder, value instanceof PhoneNumber() ? value.raw_1 : THROW_CCE());
      }
    }
    initMetadataForObject($, 'PhoneNumberSerializer', VOID, VOID, [KSerializer()]);
    PhoneNumberSerializerClass = $;
  }
  return PhoneNumberSerializerClass;
}
var PhoneNumberSerializer_instance;
function PhoneNumberSerializer_getInstance() {
  if (PhoneNumberSerializer_instance === VOID)
    new (PhoneNumberSerializer())();
  return PhoneNumberSerializer_instance;
}
function _TrimmedString___init__impl__orw15u(raw) {
  return raw;
}
function _TrimmedString___get_raw__impl__87z345($this) {
  return $this;
}
function TrimmedString__toString_impl_1ysh22($this) {
  return _TrimmedString___get_raw__impl__87z345($this);
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return TrimmedStringSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function TrimmedString__hashCode_impl_npydux($this) {
  return getStringHashCode($this);
}
function TrimmedString__equals_impl_11kln1($this, other) {
  if (!(other instanceof TrimmedString()))
    return false;
  if (!($this === other.raw_1))
    return false;
  return true;
}
function TrimmedString__compareTo_impl_v1jip4($this, other) {
  return $this.compareTo_p594d2_k$((!(other == null) ? isInterface(other, IsRawString()) : false) ? other : THROW_CCE());
}
var TrimmedStringClass;
function TrimmedString() {
  if (TrimmedStringClass === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _TrimmedString___get_raw__impl__87z345(this.raw_1);
      }
      toString() {
        return TrimmedString__toString_impl_1ysh22(this.raw_1);
      }
      hashCode() {
        return TrimmedString__hashCode_impl_npydux(this.raw_1);
      }
      equals(other) {
        return TrimmedString__equals_impl_11kln1(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return TrimmedString__compareTo_impl_v1jip4(this, other);
      }
    }
    protoOf($).compareTo_p594d2_k$ = compareTo_0;
    initMetadataForClass($, 'TrimmedString', VOID, VOID, [IsRawString()], VOID, VOID, {0: TrimmedStringSerializer_getInstance});
    TrimmedStringClass = $;
  }
  return TrimmedStringClass;
}
function _CaselessString___init__impl__ihury1(raw) {
  return raw;
}
function _CaselessString___get_raw__impl__xzssfw($this) {
  return $this;
}
function CaselessString__toString_impl_halxuh($this) {
  return _CaselessString___get_raw__impl__xzssfw($this);
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return CaselessStringSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
function CaselessString__hashCode_impl_vzc7bs($this) {
  return getStringHashCode($this);
}
function CaselessString__equals_impl_ua2id0($this, other) {
  if (!(other instanceof CaselessString()))
    return false;
  if (!($this === other.raw_1))
    return false;
  return true;
}
function CaselessString__compareTo_impl_hy5lx5($this, other) {
  return $this.compareTo_p594d2_k$((!(other == null) ? isInterface(other, IsRawString()) : false) ? other : THROW_CCE());
}
var CaselessStringClass;
function CaselessString() {
  if (CaselessStringClass === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _CaselessString___get_raw__impl__xzssfw(this.raw_1);
      }
      toString() {
        return CaselessString__toString_impl_halxuh(this.raw_1);
      }
      hashCode() {
        return CaselessString__hashCode_impl_vzc7bs(this.raw_1);
      }
      equals(other) {
        return CaselessString__equals_impl_ua2id0(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return CaselessString__compareTo_impl_hy5lx5(this, other);
      }
    }
    protoOf($).compareTo_p594d2_k$ = compareTo_0;
    initMetadataForClass($, 'CaselessString', VOID, VOID, [IsRawString()], VOID, VOID, {0: CaselessStringSerializer_getInstance});
    CaselessStringClass = $;
  }
  return CaselessStringClass;
}
function _TrimmedCaselessString___init__impl__li6it1(raw) {
  return raw;
}
function _TrimmedCaselessString___get_raw__impl__ibsfwu($this) {
  return $this;
}
function TrimmedCaselessString__toString_impl_an1uar($this) {
  return _TrimmedCaselessString___get_raw__impl__ibsfwu($this);
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return TrimmedCaselessStringSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
function TrimmedCaselessString__hashCode_impl_we7r3m($this) {
  return getStringHashCode($this);
}
function TrimmedCaselessString__equals_impl_4dmxp2($this, other) {
  if (!(other instanceof TrimmedCaselessString()))
    return false;
  if (!($this === other.raw_1))
    return false;
  return true;
}
function TrimmedCaselessString__compareTo_impl_or6pv3($this, other) {
  return $this.compareTo_p594d2_k$((!(other == null) ? isInterface(other, IsRawString()) : false) ? other : THROW_CCE());
}
var TrimmedCaselessStringClass;
function TrimmedCaselessString() {
  if (TrimmedCaselessStringClass === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _TrimmedCaselessString___get_raw__impl__ibsfwu(this.raw_1);
      }
      toString() {
        return TrimmedCaselessString__toString_impl_an1uar(this.raw_1);
      }
      hashCode() {
        return TrimmedCaselessString__hashCode_impl_we7r3m(this.raw_1);
      }
      equals(other) {
        return TrimmedCaselessString__equals_impl_4dmxp2(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return TrimmedCaselessString__compareTo_impl_or6pv3(this, other);
      }
    }
    protoOf($).compareTo_p594d2_k$ = compareTo_0;
    initMetadataForClass($, 'TrimmedCaselessString', VOID, VOID, [IsRawString()], VOID, VOID, {0: TrimmedCaselessStringSerializer_getInstance});
    TrimmedCaselessStringClass = $;
  }
  return TrimmedCaselessStringClass;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        this.serialNames_1 = setOf(['com.lightningkite.services.data.TrimmedString', 'com.lightningkite.services.data.CaselessString', 'com.lightningkite.services.data.TrimmedCaselessString', 'com.lightningkite.services.data.EmailAddress', 'com.lightningkite.services.data.PhoneNumber']);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new (Companion_4())();
  return Companion_instance_4;
}
function compareTo_0(other) {
  return compareTo(this.get_raw_18ix4x_k$(), other.get_raw_18ix4x_k$());
}
var IsRawStringClass;
function IsRawString() {
  if (IsRawStringClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'IsRawString', VOID, VOID, [Comparable()]);
    IsRawStringClass = $;
  }
  return IsRawStringClass;
}
function toEmailAddress(_this__u8e3s4) {
  _init_properties_StringAlts_kt__fevqij();
  // Inline function 'kotlin.text.trim' call
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var fixed = toString(trim(isCharSequence(_this__u8e3s4) ? _this__u8e3s4 : THROW_CCE())).toLowerCase();
  if (get_emailRegex().matches_evli6i_k$(fixed))
    return _EmailAddress___init__impl__a6ugvr(fixed);
  else
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(fixed + ' is not an email address.');
}
function toPhoneNumber(_this__u8e3s4) {
  _init_properties_StringAlts_kt__fevqij();
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.text.filter' call
  var tmp0 = _this__u8e3s4.toLowerCase();
  // Inline function 'kotlin.text.filterTo' call
  var destination = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  var inductionVariable = 0;
  var last = charSequenceLength(tmp0);
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var element = charSequenceGet(tmp0, index);
      if (!get_punctuation().contains_aljjnj_k$(new (Char())(element))) {
        destination.append_58al37_k$(element);
      }
    }
     while (inductionVariable < last);
  var fixed = destination.toString();
  var tmp;
  if (startsWith_0(fixed, _Char___init__impl__6a9atx(43))) {
    tmp = _PhoneNumber___init__impl__slwhzy(fixed);
  } else if (fixed.length === 10) {
    tmp = _PhoneNumber___init__impl__slwhzy('+1' + fixed);
  } else {
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$("Phone numbers should begin with a '+' and your country code.");
  }
  return tmp;
}
var TrimmedStringSerializerClass;
function TrimmedStringSerializer() {
  if (TrimmedStringSerializerClass === VOID) {
    class $ {
      constructor() {
        TrimmedStringSerializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('com.lightningkite.services.data.TrimmedString', STRING_getInstance());
      }
      deserialize_7sm4rp_k$(decoder) {
        // Inline function 'com.lightningkite.services.data.trimmed' call
        // Inline function 'kotlin.text.trim' call
        var this_0 = decoder.decodeString_x3hxsx_k$();
        var tmp$ret$1 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        return _TrimmedString___init__impl__orw15u(tmp$ret$1);
      }
      deserialize_sy6x50_k$(decoder) {
        return new (TrimmedString())(this.deserialize_7sm4rp_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_8xqy0c_k$(encoder, value) {
        return encoder.encodeString_424b5v_k$(_TrimmedString___get_raw__impl__87z345(value));
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_8xqy0c_k$(encoder, value instanceof TrimmedString() ? value.raw_1 : THROW_CCE());
      }
    }
    initMetadataForObject($, 'TrimmedStringSerializer', VOID, VOID, [KSerializer()]);
    TrimmedStringSerializerClass = $;
  }
  return TrimmedStringSerializerClass;
}
var TrimmedStringSerializer_instance;
function TrimmedStringSerializer_getInstance() {
  if (TrimmedStringSerializer_instance === VOID)
    new (TrimmedStringSerializer())();
  return TrimmedStringSerializer_instance;
}
var CaselessStringSerializerClass;
function CaselessStringSerializer() {
  if (CaselessStringSerializerClass === VOID) {
    class $ {
      constructor() {
        CaselessStringSerializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('com.lightningkite.services.data.CaselessString', STRING_getInstance());
      }
      deserialize_inqakw_k$(decoder) {
        // Inline function 'com.lightningkite.services.data.caseless' call
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = decoder.decodeString_x3hxsx_k$().toLowerCase();
        return _CaselessString___init__impl__ihury1(tmp$ret$1);
      }
      deserialize_sy6x50_k$(decoder) {
        return new (CaselessString())(this.deserialize_inqakw_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_3fpla1_k$(encoder, value) {
        return encoder.encodeString_424b5v_k$(_CaselessString___get_raw__impl__xzssfw(value));
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_3fpla1_k$(encoder, value instanceof CaselessString() ? value.raw_1 : THROW_CCE());
      }
    }
    initMetadataForObject($, 'CaselessStringSerializer', VOID, VOID, [KSerializer()]);
    CaselessStringSerializerClass = $;
  }
  return CaselessStringSerializerClass;
}
var CaselessStringSerializer_instance;
function CaselessStringSerializer_getInstance() {
  if (CaselessStringSerializer_instance === VOID)
    new (CaselessStringSerializer())();
  return CaselessStringSerializer_instance;
}
var TrimmedCaselessStringSerializerClass;
function TrimmedCaselessStringSerializer() {
  if (TrimmedCaselessStringSerializerClass === VOID) {
    class $ {
      constructor() {
        TrimmedCaselessStringSerializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('com.lightningkite.services.data.TrimmedCaselessString', STRING_getInstance());
      }
      deserialize_xztyoe_k$(decoder) {
        // Inline function 'com.lightningkite.services.data.trimmedCaseless' call
        // Inline function 'kotlin.text.trim' call
        var this_0 = decoder.decodeString_x3hxsx_k$();
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE())).toLowerCase();
        return _TrimmedCaselessString___init__impl__li6it1(tmp$ret$2);
      }
      deserialize_sy6x50_k$(decoder) {
        return new (TrimmedCaselessString())(this.deserialize_xztyoe_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_r0n30d_k$(encoder, value) {
        return encoder.encodeString_424b5v_k$(_TrimmedCaselessString___get_raw__impl__ibsfwu(value));
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_r0n30d_k$(encoder, value instanceof TrimmedCaselessString() ? value.raw_1 : THROW_CCE());
      }
    }
    initMetadataForObject($, 'TrimmedCaselessStringSerializer', VOID, VOID, [KSerializer()]);
    TrimmedCaselessStringSerializerClass = $;
  }
  return TrimmedCaselessStringSerializerClass;
}
var TrimmedCaselessStringSerializer_instance;
function TrimmedCaselessStringSerializer_getInstance() {
  if (TrimmedCaselessStringSerializer_instance === VOID)
    new (TrimmedCaselessStringSerializer())();
  return TrimmedCaselessStringSerializer_instance;
}
var properties_initialized_StringAlts_kt_xpptoj;
function _init_properties_StringAlts_kt__fevqij() {
  if (!properties_initialized_StringAlts_kt_xpptoj) {
    properties_initialized_StringAlts_kt_xpptoj = true;
    emailRegex = Regex().new_kotlin_text_Regex_acuq4a_k$('(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])');
    punctuation = setOf([new (Char())(_Char___init__impl__6a9atx(32)), new (Char())(_Char___init__impl__6a9atx(45)), new (Char())(_Char___init__impl__6a9atx(46)), new (Char())(_Char___init__impl__6a9atx(44)), new (Char())(_Char___init__impl__6a9atx(40)), new (Char())(_Char___init__impl__6a9atx(41)), new (Char())(_Char___init__impl__6a9atx(91)), new (Char())(_Char___init__impl__6a9atx(93)), new (Char())(_Char___init__impl__6a9atx(60)), new (Char())(_Char___init__impl__6a9atx(62))]);
  }
}
//region block: init
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
Companion_instance_2 = new (Companion_2())();
Companion_instance_3 = new (Companion_3())();
//endregion
//region block: exports
export {
  EmailAddress as EmailAddress1cvm8sbtoer9i,
  IsRawString as IsRawStringrx35rsigz3yf,
  PhoneNumber as PhoneNumber16oapr4wkp1a5,
  toEmailAddress as toEmailAddress1e4w5ykg7qyos,
  toPhoneNumber as toPhoneNumber2boyry1jrtl94,
  _EmailAddress___init__impl__a6ugvr as _EmailAddress___init__impl__a6ugvr3polh9vbc2yo8,
  EmailAddress__hashCode_impl_wizg9y as EmailAddress__hashCode_impl_wizg9y14xq3olyjcev0,
  _EmailAddress___get_raw__impl__6ose2 as _EmailAddress___get_raw__impl__6ose226bwkbm01ev3l,
  EmailAddress__toString_impl_artjh3 as EmailAddress__toString_impl_artjh3fv1lb2pg4oqn,
  _EmailAddress___get_url__impl__h7wdun as _EmailAddress___get_url__impl__h7wdun30pft8c6nophf,
  _PhoneNumber___init__impl__slwhzy as _PhoneNumber___init__impl__slwhzy3axmmryqebui0,
  PhoneNumber__hashCode_impl_t98twl as PhoneNumber__hashCode_impl_t98twlqkqzqu7p5mbp,
  _PhoneNumber___get_raw__impl__gc2pmp as _PhoneNumber___get_raw__impl__gc2pmp2jq67zyqivc5w,
  PhoneNumber__toString_impl_7i2x3q as PhoneNumber__toString_impl_7i2x3q2my82bpxyutrq,
  _PhoneNumber___get_url__impl__12igm0 as _PhoneNumber___get_url__impl__12igm01qncyrbzd7cb3,
  Companion_instance_2 as Companion_instancesxz2s5pmyc3v,
  CaselessStringSerializer_getInstance as CaselessStringSerializer_getInstance27w6j67zgbnak,
  Companion_getInstance as Companion_getInstance3d9mpftfjw6px,
  EmailAddressSerializer_getInstance as EmailAddressSerializer_getInstancezn5b5405tqyz,
  Companion_getInstance_4 as Companion_getInstance18mvmiinmr4hw,
  Companion_instance_0 as Companion_instance2u6g2z0babd2s,
  PhoneNumberSerializer_getInstance as PhoneNumberSerializer_getInstanceq35z0l42la4e,
  Companion_instance_3 as Companion_instance21aecnguozao5,
  TrimmedCaselessStringSerializer_getInstance as TrimmedCaselessStringSerializer_getInstance54hltjmd2vdo,
  Companion_instance_1 as Companion_instancehk7vx2dhtw7x,
  TrimmedStringSerializer_getInstance as TrimmedStringSerializer_getInstance74f8ucioonvq,
};
//endregion

//# sourceMappingURL=StringAlts.mjs.map
